module.exports = __webpack_public_path__ + "static/media/luotettava_kumppani.e2a7b149.png";